import { styled } from "@mui/material/styles";

export const Wrapper = styled("div")(({ theme }) => ({
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1fr",
    gap: theme.spacing(2),
    alignItems: "start",
    "&:empty": {
        display: "none",
    },
    [theme.breakpoints.down("sm")]: {
        gridTemplateColumns: "1fr 1fr",
    },
}));
